import { type Fight, type FightDispatchProps, type SetFightsProps } from 'src/types'

// consider adding props that last from game to game
const setFights = ({ fights }: SetFightsProps) => fights

export const reducer = (fights: Record<string, Fight>, action: FightDispatchProps) => {
  switch (action.type) {
    case 'SET_FIGHTS':
      return setFights(action)
    default:
      return fights
  }
}
